import { ListItemIcon, MenuItem, Select, styled, Typography } from '@mui/material';
import { palette } from 'view/themes/palette';

export const SelectLabel = styled(Typography)<{ error: string }>(({ error }) => {
  return {
    color: error ? palette.alerts.error : palette.text.header,
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: '128%',
    margin: '0 0 8px 0',
  };
});

export const CustomSelect = styled(Select)<{ error: boolean }>(({ error }) => {
  return {
    width: '100%',
    color: palette.text.body,
    lineHeight: '136%',
    borderRadius: '8px',

    '&.MuiOutlinedInput-root': {
      borderRadius: '8px',
      borderColor: 'red',
      minHeight: '40px',

      '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: error ? palette.alerts.error : palette.hover.brand,
      },

      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderWidth: '1px',
        borderColor: palette.primary.purple500,
      },

      '&.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: palette.alerts.error,
      },
    },

    '.MuiSelect-select': {
      height: '40px',
      padding: '8px 32px 8px 12px',
    },

    '.MuiMenu-paper': {
      borderRadius: '20px',
    },
  };
});

export const CustomMenuItem = styled(MenuItem)(({ theme }) => {
  return {
    color: palette.text.header,
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: '136%',
    padding: '8px',
    borderRadius: '8px',
    display: 'flex',
    justifyContent: 'space-between',
    backgroundColor: 'transparent!important',

    '&.Mui-disabled': {
      display: 'none',
    },

    '&.Mui-selected': {
      color: palette.text.header,
      fontSize: '14px',
      fontWeight: 500,
      lineHeight: '136%',

      '&:hover': {
        backgroundColor: '#F4E8FF!important', // ✅ Фон меняется только при ховере
      },
    },

    '&:hover': {
      backgroundColor: '#F4E8FF!important', // ✅ Фон меняется только при ховере
    },
  };
});

export const Checkmark = styled(ListItemIcon)({
  minWidth: 'auto!important',
  color: '#3D1E66',

  '> svg': {
    width: '20px',
    height: '20px',
  },
});

export const ErrorMessage = styled(Typography)(({ theme }) => {
  return {
    color: palette.alerts.error,
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: '16px',
    marginTop: '8px',
  };
}) as typeof Typography;
